import React from 'react';
import { useTranslation } from 'react-i18next';
import { BankInfo } from '../../components/BankInfo';
import { Layout } from '../../components/layout/redesign/Layout';
import { BigCallToAction } from '../../features/landingMain/CallToAction';
import { LayoutSpacer } from '../../components/BankInfo/LayoutSpacer';

export default function FondsdepotbankPage() {
  const { t } = useTranslation();

  return (
    <Layout>
      <LayoutSpacer />
      <BankInfo
        bankSlug="fondsdepotbank"
        title={t(`banks.fondsdepotbank.title`)}
        calculatorUrl="/fonds-provisionsrechner"
      />
      <BigCallToAction />
    </Layout>
  );
}
